"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadCalculatorData = loadCalculatorData;
const schema_1 = require("@kalkulacka-one/schema");
const utilities_1 = require("../utilities/index.js");
const fetch_file_1 = require("./fetch-file");
const url_builders_1 = require("./url-builders");
const DATA_CONFIG = {
    calculator: {
        filename: "calculator.json",
        schema: schema_1.calculatorSchema,
        required: true,
    },
    questions: {
        filename: "questions.json",
        schema: schema_1.questionsSchema,
        required: true,
    },
    candidates: {
        filename: "candidates.json",
        schema: schema_1.candidatesSchema,
        required: true,
    },
    candidatesAnswers: {
        filename: "candidates-answers.json",
        schema: schema_1.candidatesAnswers,
        required: true,
    },
    persons: {
        filename: "persons.json",
        schema: schema_1.personsSchema,
    },
    organizations: {
        filename: "organizations.json",
        schema: schema_1.organizationsSchema,
    },
};
async function loadCalculatorData({ endpoint, key, group }) {
    const fileEntries = Object.entries(DATA_CONFIG).map(([entryKey, config]) => ({
        key: entryKey,
        url: (0, url_builders_1.buildDataUrl)({ endpoint, key, group, resourcePath: config.filename }),
        schema: config.schema,
        required: "required" in config && config.required,
    }));
    const fetchPromises = fileEntries.map(({ url, required }) => (0, fetch_file_1.fetchFile)({ url }).catch((error) => {
        if (required) {
            throw error;
        }
        return undefined;
    }));
    const results = await Promise.all(fetchPromises);
    const parsedData = fileEntries
        .map(({ key, schema }, index) => {
        const data = results[index];
        if (data === undefined)
            return undefined;
        try {
            return [key, (0, utilities_1.parseWithSchema)({ data, schema: schema })];
        }
        catch (error) {
            throw new Error(`Failed to parse ${key} data: ${error.message}`);
        }
    })
        .filter((entry) => entry !== undefined);
    return {
        data: Object.fromEntries(parsedData),
        key,
        group,
        baseUrl: (0, url_builders_1.buildDataUrl)({ endpoint, key, group }),
    };
}
